import * as angular from 'angular';
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ShippersAlertsService} from "./shippers-alerts.service";
import {ShippersRequestsService} from "./shippers-requests.service";

export class ShippersService {

  /* @ngInject */
  constructor(private shippersRequestsService: ShippersRequestsService, private shippersAlertsService: ShippersAlertsService, private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  updatePassword(shipperId, password) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.shippersRequestsService.updatePassword(shipperId, password)
      .then((updatedShipper) => {
        this.shippersAlertsService.updatePasswordSuccess();
        deferred.resolve(updatedShipper);
      })
      .catch((error) => {
        this.$log.error(error);
        this.shippersAlertsService.updatePasswordError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  addShipperApi(shipper: { displayName: string, accountId: string }) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.shippersRequestsService.addShipperApi(shipper)
      .then((shipperApi) => {
        this.shippersAlertsService.addShipperApiSuccess();
        deferred.resolve(shipperApi);
      })
      .catch((error) => {
        this.$log.error(error);
        this.shippersAlertsService.addShipperApiError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.shippers')
  .service('ShippersService', ShippersService);
